import { Globals } from "../CoreApp/Globals";

export function PDecimalPlaces(aNumber, places, addThousandsSep) {
  var result;
  const decimalMarker = Globals._decimalMarker;

  if (addThousandsSep) {
    if (places > 0) {
      aNumber = aNumber.toFixed(places);
      var r = Math.floor(aNumber);
      result = r.toLocaleString();
      var d = aNumber - r;
      var m = Math.pow(10, places);
      var decR = Math.round(d * m);
      result += decimalMarker;

      var decS = decR.toString();
      var n = decS.length;
      var n1 = n;
      while (n1 < places) {
        result += "0";
        n1++;
      }
      for (var i = 0; i < n; i++) result += decS[i];
    } else {
      var r = Math.round(aNumber);
      result = r.toLocaleString();
    }
  } else {
    result = aNumber.toFixed(places).toString();
    if (decimalMarker != ".") result = result.replace(".", ",");
  }

  return result;
}
